import styled from 'styled-components'
import { BLACK } from "@styles/colors"
import { GIVONIC } from "@styles/fonts"
import LightGradientBackground from '@assets/images/HomeBackground.png'

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    padding: 16px;
    margin: 0;
    background-image: url(${LightGradientBackground});
    background-size: cover;
    background-position: center;
`;

export const EyeContainer = styled.div`
    cursor: pointer;
    padding: 0;
    margin: 0;
`;

export const BalanceText = styled.span<{ $showBalance: boolean }>`
    padding: 0;
    margin: 0;
    color: ${BLACK};
    font-size: 18px;
    font-family: ${GIVONIC.bold};
    top: ${props => props.$showBalance ? 0 : 2}px;
    display: flex;
    position: relative;
`;
